import { useTypedParams } from '@sorare/routing';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';

import { InventoryLayout } from '@sorare/gameplay/src/layouts/inventory/InventoryLayout';

import { DailyClaimButton } from 'components/rewards/DailyClaimButton';
import { LayoutParams } from 'pages/__generated__/routeParams';

const NBAInventory = () => {
  const { type } = useTypedParams<LayoutParams>();
  return (
    <InventoryLayout
      extraHeaderButton={<DailyClaimButton />}
      sport={Sport.NBA}
      type={type as Rarity}
    />
  );
};

export default NBAInventory;
